import { useAppSelector } from "../../../hooks/reduxHooks";
import { transformProvidersTableItems } from "../modules/Providers/helpers";
import { isRadiologicalEquipmentDataComplete, isSubstanceDataComplete, validateProvidersAndBuyersItemsArray, validateResponsiblesAndContractorsCarcinogenicData } from "../tabsValidationHelpers";
import { describirFaltantesParaEnviar } from "../helpers/faltantesParaEnviar";


const useCarcinogenicTabStates = () => {
    const establihsmentData = useAppSelector(
        (state) => state?.carcinogenicReport?.carcinogenicReport?.establecimiento
    );

    const substancesData = useAppSelector(
        (state) => state?.carcinogenicReport?.carcinogenicReport?.sustancias || []
    );

    const providersEmptyDeclarationCheck = useAppSelector(
        (state) => state?.carcinogenicReport?.carcinogenicReport?.proveedoresCheck
    );

    const radiologicalEquipmentEmptyDeclarationCheck = useAppSelector(
        (state) => state?.carcinogenicReport?.carcinogenicReport?.radiologicosCheck
    );

    const contractorsData = useAppSelector(
        (state) => state?.carcinogenicReport?.carcinogenicReport?.contratistas || []
    );

    const substancesCompleteStatus = useAppSelector(
        (state) => state?.carcinogenicReport?.carcinogenicReport?.sustanciasCompleto
    );

    const workersCompleteStatus = useAppSelector(
        (state) => state?.carcinogenicReport?.carcinogenicReport?.trabajadoresCompleto
    );

    const responsiblesData = useAppSelector(
        (state) => state?.carcinogenicReport?.carcinogenicReport?.responsables || []
    );

    const { isValid: isResponsiblesAndContractorDataValid, contractorErrors, responsibleErrors } =
        validateResponsiblesAndContractorsCarcinogenicData(contractorsData, responsiblesData);

    const transformedProvidersItems = transformProvidersTableItems(substancesData)

    const IS_ESTABLISHMENT_DATA_COMPLETE =
        !!establihsmentData &&
        Object.entries(establihsmentData).every(([key, value]) => {
            if (key === 'observacion') return true;
            return value !== null && value !== undefined && value !== '';
        });

    const IS_SUBSTANCES_DATA_COMPLETE = substancesCompleteStatus;

 
    const IS_PROVIDERS_AND_BUYERS_DATA_COMPLETE =
        validateProvidersAndBuyersItemsArray(transformedProvidersItems)?.isValid ||
        (transformedProvidersItems?.length === 0 && providersEmptyDeclarationCheck);


    const areAllSubstancesEquipmentsEmpty = (sustancias: any[]) =>
        sustancias.every(
            (sustancia) => !Array.isArray(sustancia.equipos) || sustancia.equipos.length === 0
        );

 const IS_RADIOLOGICAL_EQUIPMENT_DATA_COMPLETE =
     isRadiologicalEquipmentDataComplete(substancesData) ||
     (areAllSubstancesEquipmentsEmpty(substancesData) &&
         radiologicalEquipmentEmptyDeclarationCheck);

    const IS_WORKERS_AND_MEDICAL_EXAMS_DATA_COMPLETE = workersCompleteStatus === true;

    const IS_RESPONSIBLES_AND_CONTRACTORS_DATA_COMPLETE = isResponsiblesAndContractorDataValid;

    const IS_REPORT_READY_TO_PRESENT =
        IS_ESTABLISHMENT_DATA_COMPLETE &&
        IS_SUBSTANCES_DATA_COMPLETE &&
        IS_PROVIDERS_AND_BUYERS_DATA_COMPLETE &&
        IS_RADIOLOGICAL_EQUIPMENT_DATA_COMPLETE &&
        IS_WORKERS_AND_MEDICAL_EXAMS_DATA_COMPLETE &&
        IS_RESPONSIBLES_AND_CONTRACTORS_DATA_COMPLETE;

    const FALTANTES_PARA_ENVIAR = describirFaltantesParaEnviar(
        {
            datosGenerales: IS_ESTABLISHMENT_DATA_COMPLETE,
            sustancias: !!IS_SUBSTANCES_DATA_COMPLETE,
            proveedores: !!IS_PROVIDERS_AND_BUYERS_DATA_COMPLETE,
            equiposRadiologicos: !!IS_RADIOLOGICAL_EQUIPMENT_DATA_COMPLETE,
            trabajadores: IS_WORKERS_AND_MEDICAL_EXAMS_DATA_COMPLETE
        },
        responsibleErrors,
        contractorErrors,
        responsiblesData
    );

    return {
        FALTANTES_PARA_ENVIAR,
        IS_ESTABLISHMENT_DATA_COMPLETE,
        IS_SUBSTANCES_DATA_COMPLETE,
        IS_PROVIDERS_AND_BUYERS_DATA_COMPLETE,
        IS_RADIOLOGICAL_EQUIPMENT_DATA_COMPLETE,
        IS_WORKERS_AND_MEDICAL_EXAMS_DATA_COMPLETE,
        IS_RESPONSIBLES_AND_CONTRACTORS_DATA_COMPLETE,
        IS_REPORT_READY_TO_PRESENT
    };
}

export default useCarcinogenicTabStates